/* eslint-disable max-len */
// ==========================================================
// ===========================IMPORT==========================
// ===========================================================

// ==================React Hooks===================
import { useSelector } from 'react-redux';
import DOMPurify from 'dompurify';

// =========================Styles & IMG======================
import './style.scss';
import oca from '../../assets/images/oca.png';
import UE from '../../assets/images/eu_flag.jpg';
import epos from '../../assets/images/EPOS_logo_small_591_0.jpg';
import equipex from '../../assets/images/equipex-small.max-100x100.jpg';
import eposfr from '../../assets/images/Epos_France_logo.png';

function Footer() {
  // ==================Hook===================
  const dataFooter = useSelector((state) => state.footer.data);

  // function to include data of backendApi for footer in jsx
  function displayLinkBox() {
    const tabe = [];
    if (dataFooter.length !== 0) {
      for (let i = 0; i < dataFooter.link_box.length; i += 1) {
        tabe.push(
          <div key={dataFooter.link_box[i].id}>
            <h4>{dataFooter.link_box[i].value.title}</h4>
            <div key={dataFooter.link_box[i].id + dataFooter.link_box[i].value.title}>
              {dataFooter.link_box[i].value.item.map((el) => {
                const tabBis = [];
                if (el.value !== '') {
                  tabBis.push(
                    <div key={el.value}>
                      <a href={el.link} rel="noreferrer" target="_blank">
                        <span className="glyphicon glyphicon-new-window" aria-hidden="true" />
                        {el.value}
                      </a>
                    </div>,
                  );
                }
                return tabBis;
              })}
            </div>
          </div>,
        );
      }
    }
    return tabe;
  }
  return (
    /* FOOTER */
    <>
      {(dataFooter.length === 0)
        && (
          <footer>
            <div className="footer">
              <div className="column">
                <div id="portals">
                  <h4>EPOS-GNSS Node Infrastructure</h4>
                  <div>
                    <a href="#/nodeInfo" target="_blank">
                      <span className="glyphicon glyphicon-new-window" aria-hidden="true" />
                      EPOS GNSS nodes
                    </a>
                  </div>
                  <div>
                    <a href="#/nodeInfo#BecomeNode" target="_blank">
                      <span className="glyphicon glyphicon-new-window" aria-hidden="true" />
                      How to become a node ?
                    </a>
                  </div>
                  <h4>Other EPOS-GNSS portals</h4>
                  <div>
                    <a href="https://gnss-epos.eu/" rel="noreferrer" target="_blank">
                      <span className="glyphicon glyphicon-new-window" aria-hidden="true" />
                      GNSS EPOS
                    </a>
                  </div>
                  <div>
                    <a href="https://gnss-metadata.eu/site/ocoverview" rel="noreferrer" target="_blank">
                      <span className="glyphicon glyphicon-new-window" aria-hidden="true" />
                      EPOS Data Providers
                    </a>
                  </div>
                </div>

                <div id="footerLogo">
                  <h4>Funded By</h4>
                  <a href="https://www.oca.eu/fr/" rel="noreferrer" target="_blank">
                    <img alt="OCA logo" src={oca} />
                  </a>
                  <a href="https://ec.europa.eu/" rel="noreferrer" target="_blank">
                    <img alt="EU logo" src={UE} />
                  </a>
                  <a href="https://www.epos-eu.org/" rel="noreferrer" target="_blank">
                    <img alt="EPOS logo" src={epos} />
                  </a>
                  <img alt="" src={equipex} />
                  <a href="https://www.epos-france.fr/" rel="noreferrer" target="_blank">
                    <img alt="Epos-France logo" src={eposfr} />
                  </a>
                  <p id="footerLogo_paragraph">This project has received funding from the European Union’s Horizon 2020
                    research and innovation programm under grant agreement N° 676564 and French
                    RESIF-CORE Equipex project through the Investments for the Future
                    Programme of French National Agency for Research.&nbsp;
                  </p>
                </div>

                <div id="about">
                  <h4>About Us</h4>
                  <p id="about_contact"><a id="mail" href="">CONTACT US</a></p>
                  <p id="about_version">Web Client version : </p>
                </div>
              </div>
            </div>
          </footer>

        )}
      {(dataFooter.title === 'Footer')
        && (
          <footer>
            <div className="footer">
              <div className="column">
                <div id="portals">
                  {(dataFooter.link_box.length > 0) && (
                    displayLinkBox()
                  )}
                </div>

                {(dataFooter.logos.length > 0) && (
                  <div id="footerLogo">
                    <h4>Funded By</h4>
                    {dataFooter.logos.map((el) => (
                      <a key={el.id} href={el.value.link} target="_blank" rel="noreferrer">
                        <img alt={el.value.image.title} src={el.value.image.url} />
                      </a>
                    ))}
                    {(dataFooter.text_funding.length > 0) && (
                    <div dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(dataFooter.text_funding),
                    }}
                    />
                    )}
                  </div>
                )}
                <div id="about">
                  <h4>About Us</h4>
                  {(dataFooter.contact_us.length > 0) && (
                    <p id="about_contact"><a id="mail" href={`mailto:${dataFooter.contact_us}`}>CONTACT US</a></p>
                  )}
                  {/* <p id="about_version">Web Client version : {process.env.REACT_APP_VERSION}</p> */}
                  <p id="about_version">Web Client version : {process.env.REACT_APP_VERSION}</p>

                </div>
              </div>
            </div>
          </footer>
        )}
    </>
  );
}

export default Footer;
